module.exports = __webpack_public_path__ + "img/touch.cc5b1ebe.svg";